import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ContentContext = createContext(null);

const fileToUrl = (val) => {
  if (!val) return "";
  if (val.startsWith("http") || val.startsWith("data:") || val.startsWith("blob:")) return val;
  return `${process.env.REACT_APP_BACKEND_URL}${val}`;
};

export function ContentProvider({ children }) {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/content`);
      setContent(res.data);
    } catch (e) {
      console.error("Failed to load content", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <ContentContext.Provider value={{ content, loading, refresh }}>
      {children}
    </ContentContext.Provider>
  );
}

export const useContent = () => useContext(ContentContext);
export { fileToUrl };
